<template>
  <b-container fluid class="h-100">
    <b-row class="justify-content-center">
      <b-col lg="8">
        <div class="mb-4">
          <p class="display-4 font-weight-bolder mb-2">My Purchase</p>
          <span>
            All your purchase receipts will appear here. To continue verifying your competency, go
            to
            <router-link :to="{ name: 'user-dashboard' }" class="text-primary">
              User Dashboard
            </router-link>
            .
          </span>
        </div>

        <!-- Purchase History tab -->
        <!-- <b-tabs v-if="!isLoading" v-model="activeTab" pills nav-class="nav-line nav-line-alt"> -->

        <div v-if="!isLoading">
          <TabPurchaseCompleted
            v-model="currentPage"
            :purchase-order="successOrder"
            :total-items="totalItems"
            :per-page="perPage"
            :active="isTab('completed')"
          />
        </div>
        <!-- </b-tabs> -->
        <div v-else class="d-flex justify-content-center mt-5">
          <b-spinner label="Loading..." variant="dark" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import TabPurchaseCompleted from './components/TabPurchaseCompleted.vue';
import Order from '@/models/Order';
import { userInfoMixin } from '@/mixins/userInfoMixin';

const nameTabs = ['completed'];

export default {
  components: {
    TabPurchaseCompleted
  },
  mixins: [userInfoMixin],

  data() {
    return {
      isLoading: false,
      totalItems: 0,
      currentPage: this.$route.query?.page ? parseInt(this.$route.query.page) : 1,
      perPage: 10,
      searchResults: []
    };
  },
  computed: {
    successOrder() {
      return this.searchResults.filter((order) => order.latest_payment);
    },
    activeTab: {
      set(index) {
        let query = { ...this.$route.query };

        this.$set(query, 'tab', nameTabs[index]);

        this.$router.replace({ query });
      },
      get() {
        const indexTab = nameTabs.indexOf(this.$route.query.tab);

        return Number(indexTab);
      }
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(currentPage, previousPage) {
        if (currentPage) {
          this.fetch({ currentPage });
        }

        if (currentPage != previousPage && previousPage != undefined) {
          this.$router.replace({
            query: { ...this.$route.query, page: currentPage }
          });
        }
      }
    }
  },

  methods: {
    async fetch({ currentPage = 1 }) {
      this.isLoading = true;
      this.currentPage = currentPage;

      const filter = {
        _start: (this.currentPage - 1) * this.perPage,
        _limit: this.perPage,
        status: 'SUCCESS'
      };

      const { orders, totalOrders } = await Order.api().fetchWithPagination({
        filter
      });

      this.totalItems = totalOrders;
      this.searchResults = orders;

      this.isLoading = false;
    },

    isTab(tabName) {
      const { tab = '' } = this.$route.query;

      return tab.length && tab === tabName;
    }
  }
};
</script>
<style lang="scss" scoped></style>
